import React, { type ReactNode } from 'react';
import { SectionHeading, SectionTitleContainer } from '../index';

type Props = {
	icon: ReactNode;
	message: string;
};

export const SectionTitle = ({ icon, message }: Props) => (
	<SectionTitleContainer>
		{icon}
		<SectionHeading>{message}</SectionHeading>
	</SectionTitleContainer>
);
